import { Breadcrumb, Button, Col, Row, Spinner, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { useEffect, useState } from "react";
import ZoneForm from "./Form";
import Swal from "sweetalert2";
import zoneServices from "../../../redux/services/zoneServices";

const Zone = () => {
  const [loading, setLoading] = useState(false);
  const [zones, setZones] = useState([]);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    async function fetchZones() {
      setLoading(true);
      let response = await zoneServices.view();
      setLoading(false);

      if (response.status) {
        setZones(response?.data);
      }
    }

    fetchZones();
  }, [refresh]);

  const refreshZones = () => {
    setRefresh((r) => parseInt(r) + 1);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let response = await zoneServices.destory(id);

        if (response.status) {
          setRefresh((r) => parseInt(r) + 1);
        }
      }
    });
  };

  return (
    <div>
      <h1>Zone</h1>
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/admin" }}>
          Dashboard
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Master</Breadcrumb.Item>
        <Breadcrumb.Item active>Zone</Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col sm={4}>
          <ZoneForm fetchZones={refreshZones} />
        </Col>

        <Col sm={8}>
          <div className="bg-white shadow-sm p-3 rounded">
            <h4 className="text-primary pb-2 border-bottom mb-3">View Zones</h4>
            {loading ? (
              <div className="text-center">
                <Spinner variant="primary" />
              </div>
            ) : (
              <div>
                {zones?.length ? (
                  <Table bordered>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Material Type</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {zones?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}.</td>
                          <td>{item.name}</td>
                          <td>{item?.material_type?.name}</td>
                          <td>
                            <Link
                              to={`/admin/zone/edit/${item.id}`}
                              className="btn btn-link text-primary"
                            >
                              <MdModeEdit />
                            </Link>
                            <Button
                              variant="link"
                              className="text-danger"
                              onClick={() => handleDelete(item.id)}
                            >
                              <MdDelete />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <div>No record(s) found.</div>
                )}
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Zone;
